import * as moment from 'moment';
import { LOGO } from '../config/constants';
import html2canvas from "html2canvas";


export const compareDate = (a, b) => {
    let dateA = moment(a, 'DD/MM/YYYY');
    let dateB = moment(b, 'DD/MM/YYYY');
    if (dateA === dateB) return 0;
    return (dateA < dateB) ? -1 : 1;
}

export const validateDatesFilter = (from, to, date) => {
    let result = true;
    if (date.name === 'from') {
        if (moment(date.value, 'DD/MM/YYYY HH:mm').isAfter(moment(to, 'DD/MM/YYYY HH:mm'))) result = false;
    }
    if (date.name === 'to') {
        if (moment(date.value, 'DD/MM/YYYY HH:mm').isBefore(moment(from, 'DD/MM/YYYY HH:mm'))) result = false;
    }
    return result;
}

export const formatSurveys = (surveys, consultTypes, countries, provinces) => {
    return surveys.map(survey => {
        return ({
            ...survey,
            consult_type: formatConsultType(survey, consultTypes),
            procedencia: formatProcedencia(survey, countries, provinces),
            overnight_accommodation: formatAloxamento(survey)
        })
    })
}

export const formatConsultType = (item, consultTypes) => {
    let consultType = consultTypes.find((type) => {
        return item.consult_type === type.id
    });
    return !!consultType ? consultType.consult_type : '';
}

export const formatProcedencia = (item, countries, provinces) => {
    let value = "";
    if (item.origin === 140) {
        let province = provinces.find((province) => {
            return province.code === item.postal_code.substring(0, 2);
        });
        value = province && province.name;
    } else {
        let country = countries.find((country) => {
            return country.id === item.origin;
        });
        value = country && country.name_gl;
    }
    return value;
}

export const formatAloxamento = (survey) => {
    if (!!survey.overnight_accommodation){
        let accomodations = [];
        for (let accomodation of survey.overnight_accommodation) {
            switch (accomodation) {
                case "1":
                    accomodations.push('Albergue (no caso de dispoñer)');
                    break;
                case "2":
                    accomodations.push('Camping');
                    break;
                case "3":
                    accomodations.push('Barco');
                    break;
                case "4":
                    accomodations.push('Caravana');
                    break;
                case "5":
                    accomodations.push('Casa Familiares/Amigos/Propia');
                    break;
                case "6":
                    accomodations.push('Hotel');
                    break;
                case "7":
                    accomodations.push('Pensión');
                    break;
                case "8":
                    accomodations.push('Turismo Rural');
                    break;
                case "9":
                    accomodations.push('Vivenda de Aluguer/Intercambio');
                    break;
                case "10":
                    accomodations.push('Outros');
                    break;
            }
        }
        if (accomodations.length === 0) {
            accomodations = ['De paso'];
        }
        return accomodations;
    }
    return null; 
}


export const setHeader = (doc, title, subtitle) => {
    doc.setFillColor(51, 51, 51);
    doc.rect(0, 0, 500, 12, "F");
    doc.addImage(LOGO, "PNG", 5, 2, 65, 9);
    doc.setFontSize(14);
    doc.text(title, 10, 20);
    doc.setFontSize(10);
    doc.text(subtitle, 10, 25);
}

export const setGraphic = async (doc, id) => {
    const WIDTH = 100;
    const HEIGHT = 260;
    let canvas = await html2canvas(
        document.getElementById(id)
    );
    let widthCanvas = canvas.getAttribute('width');
    let heightCanvas = canvas.getAttribute('height');
    let height = WIDTH * heightCanvas / widthCanvas;
    let width = WIDTH;
    if (height > HEIGHT) {
        height = HEIGHT;
        width = (HEIGHT * widthCanvas / heightCanvas) + 10;
    }
    doc.addImage(canvas, 30, 30, width, height);
}

export const setTable = async (doc, id) => {
    const WIDTH = 55;
    const HEIGHT = 260;
    let canvas = await html2canvas(
        document.getElementById(id)
    );
    let widthCanvas = canvas.getAttribute('width');
    let heightCanvas = canvas.getAttribute('height');
    let height = WIDTH * heightCanvas / widthCanvas;
    let width = WIDTH;
    if (height > HEIGHT) {
        height = HEIGHT;
        width = (HEIGHT * widthCanvas / heightCanvas) + 10;
    }
    doc.addImage(canvas, 140, 25, width, height);
}

export const getFilterText = (filter, municipalities, offices) => {
    let municipality_text = ''
    if (filter.municipality != -1){
        let municipality = municipalities.find(municipality => {
            return municipality.id == filter.municipality
        });
        municipality_text = `/ Concello: ${municipality.name}`;
    }
    let office_text = '';
    if (filter.office != -1){
        let office = offices.find(office => {
            return office.id == filter.office
        });
        office_text = `/ Oficina: ${office.name}`;
    }

    return `${municipality_text} ${office_text}`;
}

export const setFooter = (doc, current, total) => {
    doc.setFontStyle("italic");
    doc.text(`Página: ${current}/${total}`, 185, 293);
    // doc.text(`Fecha de creación: ${moment().format('DD/MM/YYYY HH:mm')}`, 8, 293);
}


// WEBPACK FOOTER //
// ./src/utils/utils.js